export default __webpack_public_path__ + "static/media/cpv_71_service-architecture-civil-techniques.d7a2af5b.svg";